import { HttpHeaders, HttpMethods } from '../interfaces';
import { MicroservicesMap } from './microservice.interfaces';

export const API_KEY_HEADER = 'X-API-Key';
export const AUTHORIZATION_HEADER = 'Authorization';
export const CONFIG_FILE_PATH = '/config.json';
export const DISTRIBUTION_CHANNEL_HEADER = 'CD-DistributionChannel';
export const ENVIRONMENT_HEADER = 'CD-Environment';
export const JSON_LONG_AS_STRING_HEADER = 'CD-JsonLongAsString';
export const LANGUAGE_HEADER = 'CD-Language';
export const RETRY_AFTER_HEADER = 'Retry-After';
export const SERVICE_IDENTIFIER_HEADER = 'CD-ServiceIdentifier';
export const SERVICE_INSTANCE_ID_HEADER = 'CD-ServiceInstanceId';
export const SESSION_ID_HEADER = 'CD-SessionId';
export const SALES_CHANNEL_ID_HEADER = 'CD-SalesChannel';
export const INVENTORY_STORE_ID_HEADER = 'CD-InventoryStore';
export const SUBSCRIBER_EXTERNAL_REFERENCE_HEADER =
  'CD-SubscriberExternalReference';
export const SUBSCRIBER_EXTERNAL_REFERENCE_TYPE_HEADER =
  'CD-SubscriberExternalReferenceType';
export const SUBSCRIBER_ID_HEADER = 'CD-SubscriberId';
export const SYSTEM_ID_HEADER = 'CD-SystemId';

export const DISTRIBUTION_CHANNEL = {
  ID: '65C3DA02-F882-4AA5-AEFE-A70574ADA36E',
  URL_PARAM: 'DistributionChannel'
};

/** HTTP headers for an API service type. */
export const DEFAULT_HEADERS_BY_SERVICE: Record<string, HttpHeaders> = {
  common: {},
  metadata: {
    'Content-Type': 'application/json'
  },
  microservices: {
    // Accept: 'application/json',
    [API_KEY_HEADER]: undefined,
    [AUTHORIZATION_HEADER]: undefined,
    'Content-Type': 'application/json',
    [JSON_LONG_AS_STRING_HEADER]: true
  },
  services: {
    [DISTRIBUTION_CHANNEL_HEADER]: undefined,
    [JSON_LONG_AS_STRING_HEADER]: true,
    [LANGUAGE_HEADER]: undefined,
    [SALES_CHANNEL_ID_HEADER]: undefined,
    [INVENTORY_STORE_ID_HEADER]: undefined,
    [SESSION_ID_HEADER]: undefined,
    [SYSTEM_ID_HEADER]: undefined
  }
};

export const DEFAULT_TIMEOUTS: Record<string, number> = {
  METADATA: 30000,
  MICROSERVICES: 30000,
  SERVICES: 60000
};

/** HTTP methods _supported by the APIs_. */
export const HTTP_METHODS: HttpMethods = {
  GET: 'get',
  POST: 'post'
};

/** Available microservices.  */
export const MICROSERVICES: MicroservicesMap = {
  ARC: {
    CONFIGURATION: 'arc-config'
  },
  DOCUMENT_OUTPUT: 'document-output',
  DOCUMENTATION: 'documentation',
  REMARKS: 'remarks'
};

/** Map of microservices to their "name". */
export const MICROSERVICE_ENDPOINTS_MAP = {
  [MICROSERVICES.ARC.CONFIGURATION]: MICROSERVICES.ARC.CONFIGURATION,
  [MICROSERVICES.DOCUMENT_OUTPUT]: MICROSERVICES.DOCUMENT_OUTPUT,
  [MICROSERVICES.DOCUMENTATION]: MICROSERVICES.DOCUMENTATION,
  [MICROSERVICES.REMARKS]: MICROSERVICES.REMARKS
};

export const RETRIEVE_METADATA_DEFAULT_TIMEOUTS = {
  CACHE_TIME: 30 * 60 * 1000,
  STALE_TIME: 30 * 60 * 1000
};
